import _ from "lodash";

import { hasUserAtLeastOneRole } from "./authorizationHelpers";
import Auth from "../Authentication/Auth";

const requireAtLeastOneRoleHook = {
  criteria: {
    to: state => state.name !== "noRoles" && state.name !== "callback"
  },
  callback: async transition => {
    if (!_.isEmpty(Auth.getUser()) && !hasUserAtLeastOneRole()) {
      transition.router.stateService.go("noRoles");
      return false;
    }

    return true;
  }
};

export default requireAtLeastOneRoleHook;



// WEBPACK FOOTER //
// ./src/helpers/Authorization/requireAtLeastOneRoleHook.js